import { useState, SyntheticEvent, useEffect, useContext } from 'react';
import Carousel from 'react-material-ui-carousel';
import { DataContext } from 'providers/data';

import { Box } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';

import Menu from 'components/views/Menu';
import ModalClube from 'components/views/ModalClube';
import MyPerfil from 'components/views/CustomerData/MyPerfil';
import RegistrationData from 'components/views/CustomerData/RegistrationData';
import DuplicatePolicy from 'components/views/CustomerData/DuplicatePolicy';
import { ContentBodyPage, ContentNewsPage, Banner } from 'components/views/ContainersPage';

import bannerClub2 from 'assets/images/banners/desk/banner-club2-desk.png';
import BannerDadosAtualizadosDesk from 'assets/images/banners/desk/banner-dados-atualizados-desk.png';

import { TabCustom, BoxCustom } from './styles';

const dataTab = [
    {
        text: 'Dados Cadastrais',
        value: '1'
    },
    {
        text: 'Meu Perfil',
        value: '2'
    },
    {
        text: '2ª via apólice',
        value: '3'
    }
]

const CustomerData = () => {
    const [value, setValue] = useState('1');
    const [showModalClube, setShowModalClube] = useState(false);
    const { dataPerfilUser, dataCustomerForEdit, selectedCar, handleGetCustomerForEdit, handleGetPerfilUser } = useContext(DataContext);

    const handleChange = (event: SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (!dataCustomerForEdit) {
            handleGetCustomerForEdit({ token: localStorage.getItem('token')! });
        }
        if (typeof dataPerfilUser === "undefined" && selectedCar) {
            handleGetPerfilUser({ token: localStorage.getItem('token')!, nrPlatform: selectedCar.NR_PLATAFORMA });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar]);

    return (
        <Menu titlePage='MEUS DADOS'>
            <ContentBodyPage>
                <TabContext value={value}>
                    <BoxCustom>
                        <TabList onChange={handleChange} aria-label="lab API tabs example">
                            {dataTab.map(({ text, value }, index) =>
                                <TabCustom label={text} value={value} key={index} />
                            )}
                        </TabList>
                        <Box sx={{ borderBottom: '2.6px solid #8D9BB5', marginTop: '-2px' }} />
                    </BoxCustom>
                    {dataTab.map(({ text, value }, index) =>
                        <TabPanel value={value} key={index} sx={{ padding: '1.25rem 0 0' }}>
                            {value === '1' && <RegistrationData />}
                            {value === '2' && <MyPerfil />}
                            {value === '3' && <DuplicatePolicy />}
                        </TabPanel>
                    )}
                </TabContext>
            </ContentBodyPage>

            <ContentNewsPage>
                <Box sx={{
                    width: '100%',
                    maxWidth: {
                        xs: '100%',
                        md: '14.5rem'
                    },
                    display: { xs: 'none', md: 'flex' },
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    paddingBottom: {
                        xs: '1.5rem',
                        md: '0'
                    }
                }}>
                    {selectedCar?.COMODATO ?
                        [1079756].indexOf(selectedCar?.CODIGO_SEGURADORA) >= 0 ?
                            <Carousel sx={{ width: '100%', minHeight: '27.25rem', 'button': { display: 'none' } }}>
                                <Banner bannerImg={bannerClub2} link='' onClick={() => setShowModalClube(true)} />
                                <Banner bannerImg={BannerDadosAtualizadosDesk} link='/meus-dados' />
                            </Carousel>
                            :
                            <Banner bannerImg={BannerDadosAtualizadosDesk} link='/meus-dados' />
                        :
                        <Carousel sx={{ width: '100%', minHeight: '27.25rem', 'button': { display: 'none' } }}>
                            <Banner bannerImg={bannerClub2} link='' onClick={() => setShowModalClube(true)} />
                            <Banner bannerImg={BannerDadosAtualizadosDesk} link='' />
                        </Carousel>
                    }
                </Box>
            </ContentNewsPage>

            <ModalClube openModal={showModalClube} handleClickClosed={() => setShowModalClube(false)} />
        </Menu>
    );
}

export default CustomerData;